import { Content } from 'rsuite';
import { Select } from '../Select';
import { OptionsDropdown } from '../OptionsDropdown';
import { DetailingTable } from '../DetailingTable';
import { LoadingSpinerArea } from '../../../../../../components';
import { useAderenciaDetailsFilters } from '../../hooks/useAderenciaDetailsFilters';
import { useAderenciaPrecosStore } from '../../AderenciaPrecos.store';
import { OPTIONS_DROPDOWN, FILTER_LOCALE } from '../../data';
import { DetailsResponse, FilterNames } from '../../types';
import styles from './Detailing.module.scss';

type DetailingProps = {
  data: DetailsResponse;
  loading?: boolean;
  onChangePage: (page: number, size: number) => void;
  onChangeLength?: (size: number) => void;
  onClickDownload: (type: 'CSV' | 'XLSX') => void;
  onClean?: (name: string) => void;
  onClose: () => void;
  onSortColumn?: (dataKey: string, sortType: 'asc' | 'desc' | undefined) => void;
};

export const Detailing = ({ data, loading, onChangePage, onChangeLength, onClickDownload, onClean, onClose, onSortColumn }: DetailingProps) => {
  const { produtoDetailing, redeDetailing, tipoLojaDetailing, ufDetailing, produto, rede, tipoLoja, uf } = useAderenciaPrecosStore();
  const { handleCleanAderenciaDetailingFilter, handleSelectAderenciaDetailingFilter } = useAderenciaDetailsFilters();

  const handleOnClean = (name: FilterNames) => {
    handleCleanAderenciaDetailingFilter(name);
    onClean?.(name);
  };

  const FILTERS = [
    {
      name: 'PRODUTO',
      label: 'Produto',
      placeholder: produtoDetailing.value?.length ? 'Produtos selecionados' : 'Todos os produtos filtrados',
      value: produtoDetailing.value,
      data: produto.value?.length ? produto.cache : [],
    },
    {
      name: 'REDE',
      label: 'Rede',
      placeholder: redeDetailing.value?.length ? 'Redes selecionadas' : 'Todas as redes filtradas',
      value: redeDetailing.value,
      data: rede.value?.length ? rede.cache : [],
    },
    {
      name: 'UF',
      label: 'UF',
      placeholder: ufDetailing.value?.length ? 'UF’S selecionadas' : 'Todas as UF’S filtradas',
      value: ufDetailing.value,
      data: uf.value?.length ? uf.cache : [],
    },
    {
      name: 'TIPO_LOJA',
      label: 'Tipo de loja',
      placeholder: tipoLojaDetailing.value?.length ? 'Tipos de loja selecionadas' : 'Todos os tipos de loja filtrados',
      value: tipoLojaDetailing.value,
      data: tipoLoja.value?.length ? tipoLoja.cache : [],
    },
  ];

  return (
    <Content className={styles['detailing-container']}>
      <LoadingSpinerArea area="aderencia-details-download" size="md" style={{ position: 'absolute' }} />
      <div className={styles['header-wrapper']}>
        <div className={styles['header-title-wrapper']}>
          <h6 className={styles.title}>Detalhamento</h6>
          <OptionsDropdown id="detailing-more-options" data={OPTIONS_DROPDOWN} onClick={onClickDownload} />
        </div>
        <p className={styles.subtitle}>Confira o detalhamento de todos os produtos encontrados na pesquisa</p>
      </div>
      <div className={styles['filter-wrapper']}>
        {FILTERS.map((filter, index) => (
          <Select
            key={index}
            label={filter.label}
            placeholder={filter.placeholder}
            value={filter.value}
            data={filter.data}
            searchable
            filter={true}
            onSelect={(_v, item) => handleSelectAderenciaDetailingFilter(filter.name, item)}
            onClean={() => handleOnClean(filter.name)}
            onClose={onClose}
            locale={FILTER_LOCALE}
          />
        ))}
      </div>
      <DetailingTable data={data} onChangePage={onChangePage} onChangeLength={onChangeLength} onSortColumn={onSortColumn} />
    </Content>
  );
};
